/**
 * @fileoverview DELETE handler for the "/engagement/report_dashboard/:dashboard_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardIdCacheKeys } from "./constants";
import type {
  DeleteEngagementReportDashboardDashboardIdProps,
  EmptyResult as EngagementReportDashboardDeleteDashboardResult,
} from "./types";

export const deleteEngagementReportDashboardDashboardId = reactQueryMutationAdapter(
  engagementReportDashboardDashboardIdCacheKeys,
  (
    props: DeleteEngagementReportDashboardDashboardIdProps
  ): Promise<EngagementReportDashboardDeleteDashboardResult> => {
    return fetch(`/engagement/report_dashboard/${props.dashboardId}`, "DELETE", props);
  }
);
